export default __webpack_public_path__ + "maps-examples-fill-pattern-1200-452f512c251552502a673722971af807.png";